import { mapProps } from '../../../../../../../../../util/hocs';
import AlbumMembershipGroupTaggedPhotos from './AlbumMembershipGroupTaggedPhotos';
import withModal from '../../../../../../../../../components/global/modal/withModal';

export const ALBUM_MEMBERSHIP_GROUP_TAGGED_PHOTOS_MODAL =
  'ALBUM_MEMBERSHIP_GROUP_TAGGED_PHOTOS_MODAL';

const AlbumMembershipGroupTaggedPhotosModal = withModal(
  mapProps(({ onRequestClose, actionProps = {}, ...props }) => ({
    onClose: onRequestClose,
    ...actionProps,
    ...props,
  }))(AlbumMembershipGroupTaggedPhotos),
  {
    name: ALBUM_MEMBERSHIP_GROUP_TAGGED_PHOTOS_MODAL,
    size: 'md',
    type: 'full',
    hideHeader: true,
    dismissible: false,
    className: 'modal-contained',
  },
);

export default AlbumMembershipGroupTaggedPhotosModal;
